// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-TextField-control-TextField-module__description";
var _2 = "webpack-concepts-Extraction-Blocks-TextField-control-TextField-module__labelOuter";
export { _1 as "description", _2 as "labelOuter" }
